import React from 'react';
import CommonTypography from '@src/new-components/Typography';
import useNumberDraft from './useNumberDraft';
import { StyledNumberInput } from './index.style';

const NumberInput = ({ width, value, range, suffix, onChange }) => {
  const draft = useNumberDraft(value, range, onChange);

  return (
    <StyledNumberInput $width={width}>
      <input {...draft} />
      <CommonTypography
        className="number-input-suffix"
        variant="body-14-medium"
      >
        {suffix}
      </CommonTypography>
    </StyledNumberInput>
  );
};

export default NumberInput;
